import { Component, ViewChild, Injector, Output, EventEmitter} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { finalize } from 'rxjs/operators';
import { PayGradesServiceProxy, CreateOrEditPayGradeDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';
import * as moment from 'moment';

@Component({
    selector: 'createOrEditPayGradeModal',
    templateUrl: './create-or-edit-payGrade-modal.component.html'
})
export class CreateOrEditPayGradeModalComponent extends AppComponentBase {
   
    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;

    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    payGrade: CreateOrEditPayGradeDto = new CreateOrEditPayGradeDto();



    constructor(
        injector: Injector,
        private _payGradesServiceProxy: PayGradesServiceProxy
    ) {
        super(injector);
    }
    onShown():void
    {
        document.getElementById('PayGrade_Name').focus();
    }
    show(payGradeId?: number): void {
    

        if (!payGradeId) {
            this.payGrade = new CreateOrEditPayGradeDto();
            this.payGrade.id = payGradeId;

            this.active = true;
            this.modal.show();
        } else {
            this._payGradesServiceProxy.getPayGradeForEdit(payGradeId).subscribe(result => {
                this.payGrade = result.payGrade;


                this.active = true;
                this.modal.show();
            });
        }
        
    }

    save(): void {
            this.saving = true;

			
			
            this._payGradesServiceProxy.createOrEdit(this.payGrade)
             .pipe(finalize(() => { this.saving = false;}))
             .subscribe(() => {
                this.notify.info(this.l('SavedSuccessfully'));
                this.close();
                this.modalSave.emit(null);
             });
    }







    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
